<script>
    import { DialogOverlay, DialogContent } from 'svelte-accessible-dialog';
    import CloseButton from "./CloseButton.svelte";
    import LinkConverter from "./tools/LinkConverter.svelte";
    import {createEventDispatcher} from "svelte";

    export let isOpen = false;
    export let title = '';
    export let body = '';

    // export let linkConverter = false;

    const dispatch = createEventDispatcher();

    function DismissThis() {

        dispatch('dismiss');

    }

</script>

<DialogOverlay {isOpen} onDismiss="{DismissThis}">
    <DialogContent aria-label="Announcement">
        <div class="d-flex justify-content-end m-0 p-0">
            <CloseButton on:click>Close</CloseButton>
        </div>
        <h4 class="p-0 m-0 mb-3 text-primary">{title}</h4>
        <hr class="mt-3 mb-3" />
        <span class="linking-content">{@html body}</span>
        <!--{#if linkConverter !== true}-->
            <LinkConverter />
        <!--{/if}-->
        <slot />
    </DialogContent>
</DialogOverlay>
